import Swiper from "swiper";
import SwiperCore, { Navigation, Pagination, Autoplay } from "swiper/core";

// configure Swiper to use modules
SwiperCore.use([Navigation, Pagination, Autoplay]);

const swiper = new Swiper(".qualification-swiper", {
	// If we need pagination
	observer: true,
	observerParents: true,
	observeSlideChildren: true,
	autoHeight: true,
	// Navigation arrows
	navigation: {
		nextEl: ".qualification-button-next",
		prevEl: ".qualification-button-prev",
	},

	// And if we need scrollbar
	scrollbar: {
		el: ".swiper-scrollbar",
	},
});

window.qualificationPopup = function () {
	return {
		show: false,
		open(index) {
			this.show = true;
			setTimeout(() => {
				swiper.slideTo(index, 0);
			}, 50);
		},
		close() {
			this.show = false;
		},
		isOpen() {
			return this.show === true;
		},
	};
};
